/* import __COLOCATED_TEMPLATE__ from './hybrid-select.hbs'; */
import SellerPostingHybridSelect from 'sh-www/components/seller-postings/seller-posting-hybrid-select';

class GlmFieldsHybridSelect extends SellerPostingHybridSelect {}

export default GlmFieldsHybridSelect;
